import axios from "../axios.js";

var api = {
  // 记录  =>  练习记录
  exercise() {
    return axios.post("index/record/exercise");
  },
  // 记录  =>  模考记录
  mockexam() {
    return axios.post("index/record/mockexam");
  },
  //记录 =>  错题本
  error(params) {
    return axios.post("index/record/error", params);
  },
  //记录 =>  错题本
  remove(params) {
    return axios.post("index/record/removeError", params);
  },
  //记录 => 收藏夹
  topic(params) {
    return axios.post("index/record/topic", params);
  },
  //收藏题目
  joinCollect(params) {
    return axios.post("index/topic/joinCollect", params);
  },
  //取消收藏题目
  outCollect(params) {
    return axios.post("index/topic/outCollect", params);
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/api/record.js